module.exports = __webpack_public_path__ + "static/img/listwa_3.d990d06.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia/listwa_3.svg
// module id = 7RNz
// module chunks = 1